<app-paragraph variant="fs-16 fh-24 mt-3">{{ message }}</app-paragraph>
